var SetCustomFieldBlockModel = /** @class */ (function () {
    function SetCustomFieldBlockModel(data) {
        if (data === void 0) { data = undefined; }
        this.sourceFieldColName = '';
        this.sourceDisplayValue = '';
        this.sourceFieldType = '';
        this.sourceFieldAnswerType = '';
        this.targetFieldColName = '';
        this.targetDisplayValue = '';
        this.targetFieldTemplateId = undefined;
        this.targetFieldType = '';
        this.targetFieldAnswerType = '';
        this.formTemplateId = undefined;
        this.overrideExisting = false;
        if (data) {
            this.sourceFieldColName = data['sourceFieldColName'] ? data['sourceFieldColName'] : '';
            this.sourceDisplayValue = data['sourceDisplayValue'] ? data['sourceDisplayValue'] : '';
            this.sourceFieldType = data['sourceFieldType'] ? data['sourceFieldType'] : '';
            this.sourceFieldAnswerType = data['sourceFieldAnswerType'] ? data['sourceFieldAnswerType'] : '';
            this.targetFieldColName = data['targetFieldColName'] ? data['targetFieldColName'] : '';
            this.targetDisplayValue = data['targetDisplayValue'] ? data['targetDisplayValue'] : '';
            this.targetFieldTemplateId = data['targetFieldTemplateId'] ? data['targetFieldTemplateId'] : '';
            this.targetFieldType = data['targetFieldType'] ? data['targetFieldType'] : '';
            this.targetFieldAnswerType = data['targetFieldAnswerType'] ? data['targetFieldAnswerType'] : '';
            this.formTemplateId = data['formTemplateId'] ? data['formTemplateId'] : undefined;
            this.overrideExisting = !!data['overrideExisting'];
        }
    }
    return SetCustomFieldBlockModel;
}());
export { SetCustomFieldBlockModel };
